import React, { useState, useEffect, useRef, createContext } from 'react';
import { ConnectedRouter } from 'connected-react-router'
import { makeStyles } from '@material-ui/core/styles';
import './App.scss';
import CssBaseline from "@material-ui/core/CssBaseline";
import Routes from "./Routes";
import { history } from "./app/store/store";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import mobileBreakpoint from "./utils/mobileBreakpoint";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import Header from "./features/Header/Header";
import { Prompt } from './components/Prompt/Prompt';
import { PromptContextProvider } from './components/Prompt/PromptContext';
import SideNav from './menu/SideNav';
import { realTimeNotification } from 'app/notifications/realTimeNotification';
import ReactGA from "react-ga4";
import { useAuth } from "react-oidc-context";
import { setAccessToken } from "./services/authTokenStore";

import ScrollToTopButton from './components/ScrollToTopButton';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    appContainer: {
        marginTop: "5rem",
        marginLeft: "8.5rem",
        marginRight: "1rem"
    },
    appContainerMobile: {
        marginLeft: 100
    }
}));

export const AppContext = createContext();


function App() {
    const classes = useStyles();
    const isMobile = useMediaQuery(mobileBreakpoint);
    const [connection, setConnection] = useState(null);
    const [showHeaderApp, setShowHeaderApp] = useState(true);

    const auth = useAuth();

    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated && auth.user?.access_token) {
            setAccessToken(auth.user.access_token);

            // const newConnection = realTimeNotification.GetHubConnectionBuilder(auth.user.access_token);
            // setConnection(newConnection);

            console.log(`GA key ${process.env.REACT_APP_GA_KEY}`)
            if (process.env.REACT_APP_GA_KEY) ReactGA.initialize(process.env.REACT_APP_GA_KEY);
        }
    }, [auth.isLoading, auth.user, auth.isAuthenticated]);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(() => {
                    console.log('Connected!');
                    connection.on('ReceiveMessage', (receiveObject) => {
                        realTimeNotification.ProcessMessage(receiveObject, auth.user);
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);

    return (
        <AppContext.Provider value={{ showHeaderApp, setShowHeaderApp }}>
            <PromptContextProvider>
                <ConnectedRouter history={history}>
                    <Prompt />
                    <CssBaseline />
                    {auth.isAuthenticated && showHeaderApp && (
                        <>
                            <Header />
                            <SideNav />
                        </>
                    )
                    }
                    <div
                        className={`${auth.isAuthenticated && showHeaderApp ? classes.appContainer : ""} ${isMobile ? classes.appContainerMobile : ""}`}>
                        <Routes />
                    </div>

                    <ScrollToTopButton />

                    <ToastContainer />
                </ConnectedRouter>
            </PromptContextProvider>
        </AppContext.Provider>
    );
}

export default App;
